<template>
    <div class="d-flex flex-row gap-4 align-items-center">
        <DividerDotted class="mb-0 flex-grow-1"/>
        <div class="font-size-sm text-uppercase text-muted user-select-none">
            {{ title }}
        </div>
        <DividerDotted class="mb-0 flex-grow-1"/>
    </div>
</template>

<script>
import DividerDotted from "@components/Form/DividerDotted.vue";

export default {
    components: {DividerDotted},

    props: {
        title: {
            type: String,
            required: true
        }
    }
}
</script>
